import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { AcompanhamentoMeusComponent } from './acompanhamento-meus/acompanhamento-meus.component';
import { PesquisaModule } from '../libs/pesquisa/pesquisa.module';
import { DialogAllModule } from '@syncfusion/ej2-angular-popups';
import { GridAllModule } from '@syncfusion/ej2-angular-grids';
import { TagModule } from '../tag/tag.module';
import { DateRangePickerModule } from '@syncfusion/ej2-angular-calendars';
import { ButtonAllModule, CheckBoxModule } from '@syncfusion/ej2-angular-buttons';
import { CompartilhadoModule } from '../compartilhado/compartilhado.module';
import { ErrorHandlerModule } from '../libs/error-handler/error-handler.module';



@NgModule({
  declarations: [
    AcompanhamentoMeusComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    PesquisaModule,
    DialogAllModule,
    GridAllModule,
    TagModule,
    ButtonAllModule,
    ErrorHandlerModule,
    DateRangePickerModule,
    CheckBoxModule,
    CompartilhadoModule
  ],
  exports: [
    AcompanhamentoMeusComponent
  ]
})
export class AcompanhamentoMeusModule { }
